import { inject, Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { environment } from 'src/environments/environment';
import {
  DownloadReleaseDocParams,
  GetReleasesParams,
  Release,
  ReleaseProduct,
  ReleasesResponse,
} from 'src/app/types/release.type';
import { catchError, Observable, of, switchMap } from 'rxjs';
import { Response } from '../../types/common.type';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { BackendArtifact } from 'src/app/types';

const CUSTOMER_PATH = '/customer';
const RELEASE_PATH = CUSTOMER_PATH + '/release';

@Injectable({
  providedIn: 'root',
})
export class ReleaseApiService {
  private restApiService = inject(RestApiService);
  private http = inject(HttpClient);

  releases(params: GetReleasesParams): Observable<Response<ReleasesResponse>> {
    return this.restApiService.post<ReleasesResponse>(
      environment.api_url + RELEASE_PATH + '/releases',
      params,
    );
  }

  release(id: number): Observable<Response<Release>> {
    return this.restApiService.get<Release>(
      environment.api_url + `${RELEASE_PATH}/${id}`,
    );
  }

  products(): Observable<Response<ReleaseProduct[]>> {
    return this.restApiService.get<ReleaseProduct[]>(
      environment.api_url + `${RELEASE_PATH}/products`,
    );
  }

  downloadReleaseDoc(params: DownloadReleaseDocParams): Observable<boolean> {
    return this.http
      .post(`${environment.api_url}${RELEASE_PATH}/doc-download`, params, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(
        switchMap((response: HttpResponse<Blob>) => {
          if (response.body === null) {
            console.error('Received null response body');
            return of(false);
          }

          const contentType =
            response.headers.get('Content-Type') || 'application/octet-stream';
          const blob = new Blob([response.body], { type: contentType });

          saveAs(blob, params.contentName);
          return of(true);
        }),
        catchError((error) => {
          console.error('Ошибка загрузки:', error);

          return of(false);
        }),
      );
  }

  releaseBackendArtifacts(id: number): Observable<Response<BackendArtifact[]>> {
    return this.restApiService.get<BackendArtifact[]>(
      environment.api_url + `/release/${id}/backend/artifacts`,
    );
  }
}
